import { fetchSameOrigin } from '../Utils';

function authorizeExcuseNote(consultationId, excuseDuration, excuseReasonCode, note) {
  const body =  JSON.stringify({
    consultation_id: consultationId,
    excuse_duration: excuseDuration,
    excuse_reason_cd: excuseReasonCode,
    note,
  });

  return fetchSameOrigin('/excuse_notes', 'POST', { body })
    .then(() => window.location.reload());
}

export default authorizeExcuseNote;
